/* eslint-disable */

import Vue from 'vue'
import Vuex from 'vuex'
import VuexReset from '@ianwalter/vuex-reset'
import VuexPersist from 'vuex-persist'
import createMutationsSharer from "vuex-shared-mutations";
import { generic_storage } from '../_utilities/generic_storage'

import { alert } from './alert.module'
import { account } from './account.module'
import { entries } from './entries.module'
import { outreachs } from './outreachs.module'
import { groups } from './groups.module'
import { products } from './products.module'
import { customers } from './customer.module'
import { profiles } from './profile.module'
import { institutions } from './institution.module'
import { collateral } from './collateral.module'
// import { activity }   from './activity.module'
import { appointments } from './appointments.module'
import { fonts } from './font.module'
import sections from './sections.module'
import preferences from './preferences.module'
import productImage from './productImage.module'
import { events } from './events.module'
import { invitations } from './invitations.module'
import { folders } from './folder.module';
import { chat } from './chat.module';
import { catalog } from './catalog.module';

import version from './version.module'

const vuexPersist = new VuexPersist({
  key: 'stylelab',
  storage: window.localStorage,
  modules: ['preferences'],
})

Vue.use(Vuex)

const sharedMutations = [
  'account/logout',
  'entries/reset',
  // 'customers/reset',
  'products/reset',
]

export const store = new Vuex.Store({
  plugins: [
    VuexReset(),
    vuexPersist.plugin,
    createMutationsSharer({ predicate: sharedMutations })
  ],
  modules: {
    appointments,
    alert,
    account,
    entries,
    outreachs,
    groups,
    products,
    customers,
    profiles,
    sections,
    preferences,
    fonts,
    productImage,
    events,
    institutions,
    collateral,
    version,
    invitations,
    folders,
    chat,
    catalog,
    activity: generic_storage('activityService'),
    messages: generic_storage('messageService'),
    transactions: generic_storage('transactionService'),
    summary: generic_storage('summaryService'),
    carts: generic_storage('cartService'),
    clicks: generic_storage('clicksService'),
    customerProducts: generic_storage('customerProductsService'),
    customerViews: generic_storage('customerViewsService'),
  },
})
